//请自行添加语言资源
const offSiteCancellation = {
  purchOrderNo:'订单编号',
  appointmentNo:'预约单号',
  toxinSampleNo:'毒素单号',
  vehicleSignTime: '签到时间',
  sampleTimeBegin:'毒素取样时间',
  plantName:'基地',
  goodsCategoryName:'类型(干粮/潮)',
  supplierName:'供应商',
  vehicleNo:'车牌号',
  provinceName:'省',
  cityName:'市',
  countyName: '区',
  townName: '镇',
  toxicResultsStr: '毒素结果',
  cancelTime: '取消日期'
};
export default offSiteCancellation



// WEBPACK FOOTER //
// ./src/page/report/offSiteCancellation/lang/offSiteCancellation.en.js